import { BORDER, DARK_GREY, SHADOW } from '../colors'
import { theme } from '../theme'

const themeMode = theme.dark

const styles = {
  midHeaderStyle: {
    fontSize: '1.313rem',
    fontWeight: 'bold'
  },
  mainHeaderStyle: {
    fontSize: '48px',
    lineHeight: '3.5rem',
    fontWeight: 900
  },
  sectionStyle: {
    padding: '0 9.875rem'
  },
  centerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  betweenStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  centerStyleHeader: {
    display: 'flex',
    justifyContent: 'center',
    wordBreak: 'break-word',
    alignItems: 'center'
  },
  centerColumnStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  buttonStyle: {
    height: '3.75rem'
  },
  buttonWithCustomIconStyle: {
    height: '3.75rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  paneStyle: {
    maxWidth: `${window.innerWidth - 290}px`,
    padding: '1rem 4.063rem'
  },
  instructionsStyle: {
    fontSize: '1.125rem',
    fontWeight: 'bold',
    textAlign: 'center',
    margin: '1.25rem 0 0.938rem 0'
  },
  studentButtonStyle: {
    height: '3.563rem',
    width: '45%',
    margin: '0.875rem',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  fullWidth: {
    width: '100%'
  },
  pageContainerStyle: {
    margin: '0',
    padding: '1.188rem'
  },
  programCardStyle: {
    backgroundColor: theme.dark.background,
    borderRadius: '10px',
    border: BORDER,
    boxShadow: `0 2px 4px 0 ${SHADOW}`,
    width: '15rem',
    height: '19.375rem',
    margin: '5px 10px',
    padding: '0.5rem'
  },
  cardNameStyle: {
    margin: '0 1.25rem 0 1.188rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    textAlign: 'center',
    display: '-webkit-box',
    overflow: 'hidden',
    wordBreak: 'break-word',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    flex: '1',
    cursor: 'pointer'
  },
  cardImageStyle: {
    height: '13.688rem',
    width: '13.688rem',
    position: 'relative',
    bottom: '1.875rem',
    objectFit: 'contain',
    maxWidth: '100%',
    maxHeight: '100%'
  },
  placeholderStyle: {
    height: '13.688rem',
    bottom: '1.875rem',
    objectFit: 'contain',
    maxWidth: '100%',
    maxHeight: '100%',
    backgroundColor: '#252525'
  },
  labelStyle: {
    fontSize: '1.125rem',
    fontWeight: 'bold',
    marginBottom: '0.625rem'
  },
  builderContainerStyle: {
    overflowY: 'scroll',
    height: `${window.innerHeight - 304}px`,
    border: 'none'
  },
  homePageHeaderStyle: {
    fontSize: '2.25rem',
    fontWeight: 900,
    width: '100%',
    textAlign: 'left'
  },
  animationContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    minHeight: '14rem',
    height: 'fit-content',
    width: '100%',
    marginTop: '6.75rem'
  },
  homePageTextSectonStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '25%'
  },
  homePageDescriptionStyle: {
    fontSize: '1.125rem',
    fontWeight: 600
  },
  homePageCardStyle: {
    maxWidth: '25.5rem',
    minHeight: '18.5rem',
    borderRadius: '5px'
  },
  homePageCardImageStyle: {
    height: '9.375rem',
    width: 'auto'
  },
  homePageCardHeaderStyle: {
    fontWeight: 'bold',
    fontSize: '1rem',
    margin: '1rem 0'
  },
  homePageCardDescriptionStyle: {
    fontSize: '0.813rem',
    fontWeight: 500,
    marginBottom: '1.563rem'
  },
  homePageCarouselStyle: {
    width: '95%',
    alignSelf: 'flex-start'
  },
  goldDividerStyle: {
    borderTop: '2px solid gold',
    borderBottom: '2px solid gold'
  },
  questionStyle: {
    fontSize: '1.125rem',
    fontWeight: 'bold'
  },
  gradeButtonStyle: {
    fontSize: '0.5rem',
    height: '2.5rem',
    width: '2.5rem',
    margin: '0.188rem 0',
    padding: '0'
  },
  xButtonStyle: {
    marginLeft: '0.25rem',
    padding: '0.4rem 0.3rem',
    border: 'none',
    backgroundColor: 'transparent',
    height: '1.5rem'
  },
  thumb: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: '0.5rem',
    marginRight: '0.5rem',
    width: '100%',
    height: '20.938rem',
    padding: '0.25rem',
    boxSizing: 'border-box'
  },
  thumbInner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    justifyContent: 'flex-end'
  },
  thumbImg: {
    display: 'block',
    width: 'auto%',
    maxHeight: '20rem',
    overflow: 'hidden'
  },
  bigButtonStyle: {
    height: '6.813rem',
    width: '29.357rem',
    fontSize: '1.313rem'
  },
  archiveLinkStyle: {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: DARK_GREY,
    textDecoration: 'underline',
    marginLeft: '1.563rem',
    cursor: 'pointer'
  },
  h2Style: {
    fontSize: '1.714rem',
    fontWeight: 'bold'
  },
  h3Style: {
    fontSize: '1.5rem',
    fontWeight: 'bold'
  },
  dividerStyle: {
    height: '1rem',
    backgroundColor: themeMode.primary.default,
    marginTop: '-1px',
    border: 'none'
  },
  menuItemStyle: {
    boxShadow: 'none',
    color: themeMode.fontColor,
    minWidth: '16rem'
  }
}

export default styles
